// @core/stores/secret/SecretSealStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { secretApi } from '@core/api';
import type {
  HealthResponse,
  InitializeRequest,
  InitializeResponse,
  SealRequest,
  SealStatusResponse,
  UnsealRequest,
} from '@core/types/secret';

class SecretSealStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Get seal status
   */
  async GetSealStatus(params?: { }): Promise<SealStatusResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.GetSealStatus(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Health check
   */
  async Health(params?: { }): Promise<HealthResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.Health(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Initialize secret service
   */
  async Initialize(data: InitializeRequest): Promise<InitializeResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.Initialize(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Seal the service
   */
  async Seal(data: SealRequest): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.Seal(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Submit unseal key
   */
  async Unseal(data: UnsealRequest): Promise<SealStatusResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.Unseal(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const secretSealStore = new SecretSealStore();
